// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalSettings_root__31yyS"};